const rootTwo = Math.sqrt(2);

const getDataFromCircularArray = (people, indices) => {
  const [a, b] = indices;
  return (b > a) ? people.slice(a, b) : people.slice(a, people.length).concat(people.slice(0, b))
}

const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
}

const describeArc = (x, y, radius, startAngle, endAngle) => {

  var start = polarToCartesian(x, y, radius, startAngle);
  var end = polarToCartesian(x, y, radius, endAngle);

  const largeArcFlag = 1;//endAngle - startAngle <= 180 ? "0" : "1";
  const sweepFlag = 1;

  var d = [
    "M", start.x, start.y,
    "A", radius, radius, 0, largeArcFlag, sweepFlag, end.x, end.y
  ].join(" ");

  return d;
}

const getLimit = (frequency) => {
  let limit = 3
  if (frequency === "weekly") limit = 5
  else if (frequency === "monthly") limit = 7
  return limit
}

const getPeople = (list) => {
  console.log(list);
  if (list.length === 0) return []
  const noConstellationPeople = list[0].people.map(p => ({ ...p, kind: "person" }));
  //const constellations = list.slice(1, list.length).map(c => ({ kind: "constellation", name: c.constellation.name, id: c.constellation.id, people: c.people}) );
  //return noConstellationPeople.concat(constellations)
  let people = [...noConstellationPeople];
  list.slice(1, list.length).forEach(c => {
    const updatedConstellationPeople = c.people.map(p => ({ ...p, kind: "person" }));
    people = people.concat(updatedConstellationPeople);
  });
  return people;
}

const getFirstName = (name, separator= " ") => {
  if (!name) return name;
  const nameArray = name.split(separator);

  if (nameArray.length >= 1)
    return `${nameArray[0]}`;

  return name;
}

export {
  rootTwo,
  getDataFromCircularArray,
  getLimit,
  getPeople,
  describeArc,
  getFirstName,
}